// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".incompleted-irrigations[data-v-02e81014] {\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAF0lEQVQIW2NkQAP////3YaRQEGQGuhEAFpIQc5htOmUAAAAASUVORK5CYII=);\n}\n.disable-links a[href=\"#\"][data-v-02e81014], .disable-links a[href=\"\"][data-v-02e81014] {\n  pointer-events: none;\n}\n.disable-link[data-v-02e81014] {\n  pointer-events: none !important;\n}", ""]);
// Exports
module.exports = exports;
